export const SNOWPACK_PUBLIC_BRANCH = "HEAD";
export const SNOWPACK_PUBLIC_REV = "9362e13";
export const SNOWPACK_PUBLIC_VERSION = "0.1.0";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;